import { createSlice } from '@reduxjs/toolkit'

const height = '6.2vh'
const MIN_HEIGHT_BAR = '42px'

export const draweLeft = createSlice({
  name: 'drawerLeft',
  initialState: {
    open: false,
    drawerWidth: 200,
    drawerHeight: height,
    drawerMinHeight: MIN_HEIGHT_BAR,
    drawerWidthMin: '40px',
    contentBox: `calc(100vh - max(${MIN_HEIGHT_BAR}, ${height}))`,
  },
  reducers: {
    show: (state, action) => {
      state.open = action.payload
    },
  },
})

export const { show } = draweLeft.actions
export default draweLeft.reducer
